import { render, staticRenderFns } from "./importgatewaysfromovmodal.vue?vue&type=template&id=20c8d9c8&scoped=true"
import script from "./importgatewaysfromovmodal.vue?vue&type=script&lang=js"
export * from "./importgatewaysfromovmodal.vue?vue&type=script&lang=js"
import style0 from "./importgatewaysfromovmodal.vue?vue&type=style&index=0&id=20c8d9c8&prod&scoped=true&lang=css"
import style1 from "./importgatewaysfromovmodal.vue?vue&type=style&index=1&id=20c8d9c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c8d9c8",
  null
  
)

export default component.exports